import { useTranslation } from "react-i18next";
import css from "./CustomFields.module.css";
import { convertDate } from "../../services/luxonHelper";

function CustomFields({ customMetaData, dueDate }) {
  const { t } = useTranslation();
  const customFields = customMetaData?.map((customField) => {
    const data = { ...customField };
    if (customField.type === "DATE") {
      data.value = convertDate(Number(data.value), "dateForText");
    }
    return data;
  });

  return (
    <div className={css.customFiledDetails}>
      {dueDate && (
        <div className={css.DetailsInfo}>
          <span className={css.label}>{t("Due Date")}</span>
          <span className={css.cardType}>
            <span>{convertDate(Number(dueDate), "dateForText")}</span>
          </span>
        </div>
      )}
      {customFields?.map((customField) => (
        <div key={customField.title} className={css.DetailsInfo}>
          <span className={css.label}>{customField.title}</span>
          <span className={css.cardType}>
            <span>{customField.value}</span>
          </span>
        </div>
      ))}
    </div>
  );
}

export default CustomFields;
